module.exports = __webpack_public_path__ + "static/media/logostrip2.67a3646a.jpg";